import type { IConfig } from './models';

export const configDesktop: IConfig = {
    bold: 'accent-primary-large',
    light: 'primary-small',
    default: 'accent-primary-large',
};

export const configMobile: IConfig = {
    bold: 'accent-primary-medium',
    light: 'primary-small',
    default: 'accent-primary-medium',
};
